import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Report, ReportDefinition } from "@shared/models/user.model";
import { NgRedux } from "@shared/redux/redux-compatibility.service";
import { AppState } from "@shared/redux/store";
import { CommonService } from "@shared/services/common.service";
import { SharedService } from "@shared/services/shared.service";

@Component({
    selector: 'edit-report',
    templateUrl: './edit-report.component.html',
    styleUrls: ['./edit-report.component.scss'],
    standalone: false
})
export class EditReportComponent implements OnInit {

    constructor(private commonService: CommonService,
        private ngRedux: NgRedux<AppState>,
        private translateService: TranslateService,
        private sharedService: SharedService
    ) { }

    @Input() report: Report;

    @Output() onSave = new EventEmitter<Report>();
    @Output() onClose = new EventEmitter<void>();

    reportDefinitions: ReportDefinition[] = [];
    loading = true;
    saving = false;
    selectedReportDefinition: ReportDefinition;
    ngOnInit(): void {
        // Initialization logic here
        this.report.saveOriginal();
        if (this.reportDefinitions == null || this.reportDefinitions.length == 0) {
            this.loading = true;
            // Fetch report definitions
            let envId = this.ngRedux.getState().curEnv.id;
            this.commonService.getReportDefinitions(envId).subscribe(definitions => {
                this.reportDefinitions = definitions;
                this.loading = false;
            });
        }
    }
    isDirty(): boolean {

    return this.report.isDirty();

    }
    close() {
        if (this.isDirty()) {
        let validationStr = this.translateService.instant(
            'translate.cat.discardEditChanges'
        );

        this.sharedService.emitPopupchReceivedEvent({
            title: 'translate.validation.confirm',
            icon: 'exclamation-triangle',
            subTitle: validationStr,
            keep: false,
            approve: () => {
            this.discardChanges();
            this.onClose.emit();
            },
        });
        } else {
        this.onClose.emit();
        }
    }

    discardChanges() {
        
        this.report.restoreOriginal();
    }

    selectReportDefinition(reportDefinition: any) {
        const selectedValue: ReportDefinition = reportDefinition.value;
        this.report.reportDefId = selectedValue.id;
        this.selectedReportDefinition = selectedValue;
        this.updateReportName();
    }
    updateReportName() {
        
    
        this.report.reportName = this.selectedReportDefinition?.name || '';
        
        // so assign - only if left part is not empty
        let notEmptyValue: boolean = false;
        if (this.selectedReportDefinition?.name != null) {
            notEmptyValue = true;
        }
        if (this.report.startDate != null) {
            if (notEmptyValue) {
                this.report.reportName +=  ' - ';
            }
            
            this.report.reportName += this.report.startDate.getFullYear() + '-' + String(this.report.startDate.getMonth() + 1).padStart(2, '0') + '-' + String(this.report.startDate.getDate()).padStart(2, '0');
            notEmptyValue = true;
        }
        if (this.report.endDate != null) {
            if (notEmptyValue) {
                this.report.reportName +=  ' - ';
            }
            this.report.reportName += this.report.endDate.getFullYear() + '-' + String(this.report.endDate.getMonth() + 1).padStart(2, '0') + '-' + String(this.report.endDate.getDate()).padStart(2, '0');
        }
        
    }
    allowSubmit(): boolean {

        return this.report && this.report.startDate && this.report.endDate && this.report.reportDefId && (this.report.reportName != null) && this.report.endDate.getTime() >= this.report.startDate.getTime(); 
    }
    updateReport() {
        
        this.saving = true;
        this.report.envId = this.ngRedux.getState().curEnv.id;
        this.commonService.addReport(this.report).subscribe(updatedReport => {
        this.saving = false;
        this.report = updatedReport;
        this.onSave.emit(this.report);
        });

    }
    onDateChange(event: any, isStartDate: boolean) {
        let value = (event.target as HTMLInputElement).value;
        if (value == '') {
            if (isStartDate) {
                this.report.startDate = null;
                // set value in form to null
                
            } else {
                this.report.endDate = null;
            }
            this.updateReportName();
            return;
        }
        if (isStartDate) {
            this.report.startDate = new Date(value + 'T00:00:00');
        } else {
            this.report.endDate = new Date(value + 'T23:59:00');
        }
        this.updateReportName();
    }


}
